/**
 * Versão e vocabulário do protocolo em tempo real.
 *
 * `PROTOCOL_VERSION` viaja no `hello` do WebSocket e em `GET /v1/meta`. Quando
 * o número do cliente difere do número do servidor, o cliente fecha a conexão
 * com 4001 e pede atualização (WEBSOCKET 1, SERVER 9).
 */
/** Versão atual do protocolo, fixada em `docs/WEBSOCKET.md`. */
export const PROTOCOL_VERSION = 3;
/**
 * Códigos de fechamento do WebSocket.
 *
 * A faixa 4000 é nossa. 1001 e 1013 são do próprio protocolo WebSocket e estão
 * aqui porque o cliente precisa reagir a eles do mesmo jeito.
 */
export const WS_CLOSE = {
    /** Sem pong dentro da janela do heartbeat. */
    GOING_AWAY: 1001,
    /** Buffer de envio estourado, o cliente deve reconectar com backoff. */
    TRY_AGAIN_LATER: 1013,
    /** Ticket inválido, expirado ou já usado. */
    INVALID_TICKET: 4000,
    /** `protocolVersion` diferente do servidor. */
    VERSION_MISMATCH: 4001,
    /** Passou do limite de conexões simultâneas por usuário. */
    TOO_MANY_CONNECTIONS: 4002,
    /** Conta banida. */
    BANNED: 4003,
    /** Excesso de mensagens depois do aviso `err RATE_LIMITED`. */
    RATE_LIMITED: 4004,
};
/** Prefixos de canal aceitos na inscrição (WEBSOCKET 3). */
export const CHANNEL_KINDS = ["user", "league", "match", "challenge"];
/** Canal único e sem identificador, usado pela fila do ranked. */
export const RANKED_QUEUE_CHANNEL = "ranked:queue";
/** Tipos de mensagem que o servidor envia (WEBSOCKET 4). */
export const SERVER_MESSAGE_TYPES = [
    "hello",
    "ack",
    "err",
    "resync",
    "league.state",
    "league.deadline.warning",
    "league.round.processing",
    "league.round.processed",
    "league.presence",
    "league.member.joined",
    "league.member.left",
    "league.member.kicked",
    "league.paused",
    "league.resumed",
    "league.finished",
    "league.log",
    "match.start",
    "match.event",
    "match.pause",
    "match.end",
    "market.offer.received",
    "market.offer.updated",
    "market.auction.opened",
    "market.auction.closed",
    "chat.message",
    "chat.typing",
    "user.notification",
    "user.entitlements",
    "user.session.revoked",
];
/** Tipos de mensagem que o cliente envia (WEBSOCKET 5). */
export const CLIENT_MESSAGE_TYPES = [
    "sub",
    "unsub",
    "league.ready",
    "match.sub",
    "chat.send",
    "chat.typing",
    "ping",
];
/**
 * Monta o nome de um canal.
 *
 * Existe para que ninguém escreva `league:` concatenado à mão em um lado e
 * `leagues:` no outro.
 */
export function channelName(kind, id) {
    return `${kind}:${id}`;
}
//# sourceMappingURL=protocol.js.map